import React, { FC, useState, useEffect, useContext } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import history from '../../../../history'
import { Modal } from 'react-responsive-modal'
import { useLocation } from 'react-router-dom'
import AppContext from '../../../../context/appContext'


import { NavContainer, SwitchContainer } from "../../style"
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericColumn from '../../../../GenericComponents/GenericColumn'
import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericIcon from '../../../../GenericComponents/GenericIcon'
import { modalStyles } from '../../../NavigationBar/NavigationBar'
import ProfileIcon from '../../../../assets/REDESIGN_Assets/NavigationBar/profile-icon.png'
import DietDemoModeNotification from '../../../NavigationBar/views/DietDemoModeNotification'

import MiazgaIcon from '../../../../assets/REDESIGN_Assets/LoginScreen/miazga-logo.png'
import DietIcon from '../../../../assets/REDESIGN_Assets/NavigationBar/diet-icon.png'
import TrainingIcon from '../../../../assets/REDESIGN_Assets/NavigationBar/training-icon.png'
import ThemeSwitchDark from '../../../../assets/REDESIGN_Assets/NavigationBar/theme-switch-dark.png'

import { getUserData } from '../../../../Api/backendApi'

import "../../style/style.css"

interface NavigationInterface {
  userHasDietModule?: boolean
}

const Navigation: FC<NavigationInterface> = ({ userHasDietModule }) => {

  const [isModalOpen, setModalOpen] = useState(false)
  const [appVersion, setAppVersion] = useState(false)
  const [user, setUser] = useState<any>()
  const location = useLocation()
  const appContext = useContext(AppContext)

  useEffect(() => {
    obtainUser()
  }, [])

  const redirectToFullApp = () => {
    history.push("/trening")
  }



  const changeTheme = () => {
    if (appContext && appContext.appState.theme == 'light') {
      appContext.updateAppState('theme', 'dark')
    } else {
      appContext.updateAppState('theme', 'light')
    }
  }

  const obtainUser = async () => {
    // if (appContext.appState.user) {
    //   setUser(appContext.appState.user)
    // }

    const user: any = await getUserData()
    setUser(user)

    // appContext.updateAppState('user', user)
  }

  return (
    <NavContainer className={isMobile ? "mobile-view" : ""}>
      {/* Switch between miazga modes row */}
      {/* {!isMobile && <GenericRow width={"50%"} justify="flex-start">
        <SwitchContainer>
          <GenericTextSpan margin="0 5px 0 0">Pełna wersja MIAZGI</GenericTextSpan>
          <label className="switch">
            <input type="checkbox" onChange={redirectToFullApp} />
            <span className="slider round"></span>
          </label>
          <GenericTextSpan margin="0 0 0 5px">Wyzwania</GenericTextSpan>
        </SwitchContainer>
      </GenericRow>} */}

      {/* diet and profile row */}
      <GenericRow justify="flex-end" width={isMobile ? "100%" : "50%"} className="pointer">


        <GenericColumn align="center" width={isMobile ? "33%" : "25%"} onClick={true ? () => history.push({ pathname: '/wyzwania', state: { challengeMode: true } }) : () => setModalOpen(true)}>
          <GenericIcon
            // margin={'0 5% 0 0'}
            width={isMobile && !isTablet ? '8vw' : isTablet ? "2.5vw" : '2vw'}
            height={isMobile && !isTablet ? '8vw' : isTablet ? "2.5vw" : '2vw'}
            src={TrainingIcon}
            className={`navbar-icon ${location && location.pathname.includes("wyzwania") ? "active" : "inactive"}`}
          ></GenericIcon>
          {!isMobile && <GenericTextSpan fSize={'0.8rem'} margin="5px 0 0 0">
            Wyzwania
          </GenericTextSpan>}

        </GenericColumn>

        <GenericColumn align="center" width={isMobile ? "33%" : "25%"} onClick={user && user.diet_panel_access ? () => history.push({ pathname: '/dieta', state: { challengeMode: true } }) : () => setModalOpen(true)}>
          <GenericIcon
            // margin={'0 5% 0 0'}
            width={isMobile && !isTablet ? '8vw' : isTablet ? "2.5vw" : '2vw'}
            height={isMobile && !isTablet ? '8vw' : isTablet ? "2.5vw" : '2vw'}
            src={DietIcon}
            className={`navbar-icon ${location && location.pathname.includes("dieta") ? "active" : "inactive"}`}
          ></GenericIcon>
          {!isMobile && <GenericTextSpan fSize={'0.8rem'} margin="5px 0 0 0">
            Dieta
          </GenericTextSpan>}

        </GenericColumn>
        <GenericColumn width={isMobile ? "33%" : "25%"}>

          <GenericIcon
            width={isMobile && !isTablet ? '8vw' : isTablet ? "2.5vw" : '2vw'}
            height={isMobile && !isTablet ? '8vw' : isTablet ? "2.5vw" : '2vw'}
            className={`navbar-icon ${location && location.pathname.includes("twoj-profil") ? "active" : "inactive"}`}
            src={ProfileIcon}
            onClick={() => history.push({ pathname: '/twoj-profil', state: { challengeMode: true } })}
          ></GenericIcon>
          {!isMobile && (
            <GenericTextSpan fSize={'0.8rem'} margin={' 5px 0 0 0 '}>
              Profil
            </GenericTextSpan>
          )}

        </GenericColumn>


        {!isMobile && <GenericColumn onClick={() => changeTheme()} width="10%" margin={'0 0 0 25%'}>


          <GenericIcon
            width={'1.5vw'}
            height={'1.5vw'}
            src={ThemeSwitchDark}
          ></GenericIcon>
          <GenericTextSpan fSize={'0.8rem'} margin={' 10px 0 0 0 '}>
            Tryb
          </GenericTextSpan>


        </GenericColumn>}



      </GenericRow>

      {/* <GenericColumn margin=" 0 0 0 40%" width="50%" className="pointer" onClick={() => history.push("/dieta")} >
        <GenericButton>
          Przejdź do MIAZGI
        </GenericButton>

      </GenericColumn> */}
      <Modal
        open={isModalOpen}
        animationDuration={700}
        onClose={() => setModalOpen(false)}
        center
        styles={modalStyles}
      >
        <DietDemoModeNotification
          closeModal={() => setModalOpen(false)}
          goToSub={() => history.push({ pathname: "/wyzwania/kup-pakiet", state: { package: "diet" } })}
          modalMode={"Wyzwania panel diet"}
        />
      </Modal>
    </NavContainer>
  )
}

export default Navigation
